import { alpha, Theme } from '@mui/material';

export default {
    previewIcon: {
        width: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.primary',
        mr: 1,
        '&.icon-type--mi': {
            fontSize: '16px',
        },
        '&.icon-type--fa': {
            fontSize: '14px',
        },
    },
    image: {
        '.upload-file': {
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
            visibility: 'hidden',
        },
        '.upload-image-preview': {
            width: '14px',
            height: '14px',
        },
    },
    iconsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '0 8px 8px 0',
        overflow: 'auto',
        maxHeight: '224px',
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.24)}`,
    },
    iconItem: {
        display: 'flex',
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.24)}`,
        borderRadius: 1,
        width: '28px',
        height: '28px',
        margin: '8px 0 0 8px',
        alignItems: 'center',
        justifyContent: 'center',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.64),
        '&:hover': {
            backgroundColor: 'primary.main',
            color: 'background.default',
            cursor: 'pointer',
        },
        '&.icon-type--mi': {
            fontSize: '16px',
        },
        '&.icon-type--fa': {
            fontSize: '14px',
        },
    },
    emptySearchMsg: {
        margin: '8px 0 0 8px',
        textAlign: 'center',
        width: '100%',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.64),
    },
};
